import { enumSalesLoadLineItemPhase } from '@rematter/frontend-lib-api-client';
import { Step } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import { selectAtom } from 'jotai/utils';
import isEqual from 'lodash/isEqual';

import { $lineItemsByPhaseKey, $loadForm } from '../../_state/loadForm.state';
import { LoadFormState } from '../../types/load';
import { loadHasBeenReceived } from '../../utils/load';

const loadMaterialsFormSelector = (state: LoadFormState) => ({
  status: state.status,
});

export const MaterialsTabSize = () => {
  const form = useAtomValue(
    selectAtom($loadForm, loadMaterialsFormSelector, isEqual),
  );

  const lineItemsByPhase = useAtomValue($lineItemsByPhaseKey);

  const isLoadReceived = loadHasBeenReceived(form?.status);

  const relevantLineItems = isLoadReceived
    ? lineItemsByPhase[enumSalesLoadLineItemPhase.Shipped]
    : lineItemsByPhase[enumSalesLoadLineItemPhase.Requested];

  return relevantLineItems?.length ? (
    <Step
      number={relevantLineItems?.length}
      isCompleted={false}
      isCurrent={false}
      size="small"
    />
  ) : null;
};
